module.exports = __webpack_public_path__ + "img/t4-email.39f4e261.png";